<template>
  <div class="pc-list" ref="list">
    <BestPracticeSearch @search="search" />

    <div class="pc-list-head">
      <!-- <el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox> -->
      <!-- <el-checkbox v-model="isSelectAll">全选&nbsp;&nbsp;{{ '(已选' + selectCount + '个)' }}</el-checkbox> -->
      <div class="pc-list-head-handle">
        <div class="pc-list-head-btn">
          <button @click="deleteUser">删除</button>
          <span></span>
          <button @click="addTeacher">添加</button>
          <span></span>
          <button @click="exportUser">导出数据</button>
        </div>
        <p>{{ "共" + dataArgs.total + "条" }}</p>
      </div>
    </div>

    <el-table class="pc-list-table" @sort-change="changeSort" :data="dicList">
      <el-table-column width="100">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="singleCheck(scope.$index, scope.row.isSelect,scope.row.id)"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="头像" sortable width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.image" class="eltable-img">
            <img :src="scope.row.image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="160"></el-table-column>
      <el-table-column prop="university.name" label="所属院校" width="150">
      </el-table-column>
      <el-table-column label="标签" width="350">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.tags" :key="index">
            {{ item.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="award.name"
        label="来源"
        sortable
        width="120"
      ></el-table-column>
      <el-table-column label="状态" width="170" prop="status" sortable="custom">
        <template slot-scope="scope">
          <!-- scope.row.status -->
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            disabled
            :class="{
              'switch-is-active': scope.row.status,
              'switch-is-not-active': !scope.row.status
            }"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" sortable="custom" prop="createTime" width="120">
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.createTime).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
    >    
    <el-form>
     <el-form-item prop="personId" label="设计师"  class="personSel">
        <el-select
          v-model="addPerson.personId"
          lable="WUPEN联盟" 
          placeholder="选择设计者"
          @change="savePerson"
        >

         <el-option
                v-for="(item, index) in personOption"
                :key="index"
                :value="item.id"
                :label="item.name ? item.name : item.englishName"
                :disabled="item.disabled"
              >
              </el-option>
        </el-select>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPracticePerson"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <Pagination
      v-if="dicList.length > 0"
      class="pagination"
      :pagination="dataArgs"
      @goPage="goPage"
      @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage"
    />
  </div>
</template>



<script>
import Pagination from "../../../template/Pagination";
import BestPracticeSearch from "./BestPracticeSearch";
import {getPersons,addPracticePerson,deletePracticePersons} from './personTable.gql'
import { getPractices, deletePractice } from "../bestPracticeList.gql";
export default {
  components: {
    BestPracticeSearch,
    Pagination
  },
  watch: {},
  data() {
    return {
      selectIndex: null,
      isCancelSingle: true,
      isSelectAll: false,
      selectCount: 0,
      userArgs: {
        skip: 0,
        take: 5,
        status: 1,
        order: "+id",
      },
      // 学者设计师的后端接口
      dataArgs: {
        keywords: this.$route.params.name,
        take: 10,
        skip: 0,
        order: "-updateTime",
        type: null,
        status: 1
      },
    //   学者新增的接口参数
    addPerson:{
        practiceAwardId:'',
        data:{ids:[]}
    },
    // 学者设计师数组
    dicList: [],
    //   学者设计师下拉列表
    personOption:[],
    // 已选择的下标
      checked: [],
    //   新增设计师显示的样式
    dialogVisible:false
    };
  },
  created() {
     // 判断路由查看是否需要根据奖项查询Table
 
    // this.getUsers();
  },
  mounted() {
     this.routerAwardsTable() 
     this.getPersonsList()
    
  },
  methods: {
    // 判断路由查看是否需要根据奖项查询Table
    routerAwardsTable(){
      if(this.$route.path=='/admin/awardslist'){
        this.dataArgs.keywords=this.$route.query.name
        this.getPersons();
        // this.getPractices()
      }else{
        console.log('列表页')
      }
    },
    // 获取下拉列表的学者
    getPersonsList(){
        let dataArgs={take:0,status:1,order: "-updateTime",}
    this.$global.GraphqlQuery(this, getPersons, dataArgs).then(res => {
        this.personOption=res.data
      });
    },

    // 学者的后端
    getPersons(){
        this.$global.GraphqlQuery(this, getPersons, this.dataArgs).then(res => {
         for (let i = 0; res.data.length > i; i++) {
            res.data[i].isSelect = false;
            if(res.data[i].status=="1"){
              res.data[i].status = true
            }else{
              res.data[i].status=false
            }
          }
          this.dataArgs.total=res.total
          this.dicList=res.data
          this.removeTag();
      });
    },
   
    // 大学的后端接口
    getPractices() {
      this.$global.GraphqlQuery(this, getPractices, this.dataArgs).then(res => {
        this.checked = [];
        this.dataArgs.total = res.total;
        for (let i = 0; res.data.length > i; i++) {
          res.data[i].isSelect = false;
          if (res.data[i].status == "1") {
            res.data[i].status = true;
          } else {
            res.data[i].status = false;
          }
          // res.data[i].status = res.data[i].status == "1" ? true : false;
        }
        this.dicList = res.data;
        // this.tabName = '1'
        this.removeTag();
      });
    },
    // 过滤标签
    removeTag() {
      for (let i = 0; this.dicList.length > i; i++) {
        let a = [];
        a.push(this.dicList[i].name);
        this.dicList[i].city && a.push(this.dicList[i].city.name);
        this.dicList[i].country && a.push(this.dicList[i].country.name);
        this.dicList[i].continent && a.push(this.dicList[i].continent.name);
        this.dicList[i].tags.forEach((tag, index) => {
          a.forEach(item => {
            if (item == tag.name) {
              this.dicList[i].tags.splice(index, 1);
            }
          });
        });
        this.dicList[i].tags = this.dicList[i].tags.slice(0, 3);
      }
    },
    // 排序
    changeSort(val){
      if(val.order=='ascending'){
        this.dataArgs.order = "+" + val.prop
      }
      if(val.order=='descending'){
        this.dataArgs.order = "-" + val.prop
      }
      if(val.order==null){
        this.dataArgs.order = '-updateTime'
      }
      this.dataArgs.skip = 0
      this.getPersonsList()
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/scholardetail",
        query: { id: item.id },
        name: "scholardetail",
        params: item
      });
      window.open(route.href, "_blank");
      
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.dicList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.dicList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect,rowID) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    search(val) {
        this.dataArgs = {
          keywords:val.wupenLegend,
        title:val.title,
        take: 10,
        skip: 0,
        order: "-updateTime",
        type: null,
        status: -1,
      }
      this.getPersons()
    },
    // 删除用户
    deleteUser() {
this.addPerson.practiceAwardId=this.$route.query.id
    this.addPerson.data.ids=this.checked
       this.$global
          .GraphqlMutation(this, deletePracticePersons, {
            // Parameters
            data: this.addPerson.data,
            practiceAwardId: this.addPerson.practiceAwardId
          })
          .then(res => {
            this.isSelectAll=false
            this.checked=[]
             this.getPersons()
             
          });

      setTimeout(() => {
        // this.getPractices()
      }, 500);
      // window.location.reload()
    },
    // input保存id
    savePerson(id){
    },
    // 添加用户
    
    // 新增用户
    addPracticePerson(){
        this.dialogVisible = false
         this.$global
        .GraphqlMutation(this, addPracticePerson, {
          // Parameters
          personId:this.addPerson.personId,
          practiceAwardId:this.addPerson.practiceAwardId
        })
        .then(res => {
          this.getPersons();
        });
    },
    addUser() {
      let route = this.$router.resolve({
        path: "/admin/bestpracticedetail",
        name: "bestpracticedetail"
      });
      window.open(route.href, "_blank");
    },
    // 添加该奖项学者得奖名单
    addTeacher(){
        this.addPerson.practiceAwardId=this.$route.query.id
        this.dialogVisible=true
    },
    // 到出数据
    exportUser() {
      console.log(123);
    },

    goPage(data) {
      this.dataArgs.skip = (data - 1) * 10;
      this.getPersons();
      window.scrollTo(0, this.$refs.list.offsetTop + 210);
    }
  }
};
</script>



<style lang="scss" scoped>
.pc-list {
  margin-top: 40px;
  padding: 60px 20px 55px 40px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-list-head {
    margin-top: 40px;
    border-top: 1px solid #c0c0c0;
    padding-top: 35px;
    margin-bottom: 35px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 20px;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }

        button {
          width: 100px;
          // height: 30px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }

        button:hover {
          background: $blueBtn;
          color: white;
        }

        p {
          margin-left: 32px;
        }
      }
    }
  }

  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .el-table__body-wrapper {
      min-height: 713px;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
    }
    /deep/ .is-leaf {
      border-top:1px solid #EBEEF5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
  }

  .pagination {
    margin-top: 45px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
.eltable-img {
  max-width: 100px;
  max-height: 50px;

  img {
    width: 130px;
    height: 50px;
    object-fit: contain;
  }
}
// 弹框样式
.personSel{
    display: flex;
    justify-content: center;
}
/deep/ .el-dialog__footer{
    display: flex;
    justify-content: center;
}
// 
// /deep/ .el-checkbox__label{
//   padding-left: 7px;
// }
</style>


// WEBPACK FOOTER //
// src/components/admin/bestPractice/components/personTable.vue